//
//

import { mapGetters, mapActions } from "vuex";
import { debounce, scroll } from "quasar";
import {
    editProcessPermissions,
    publishAppPermissions,
    eventBus
} from "@/assets/js/appFunc";
import { ENGINE_REST_PATH } from "@/assets/js/appConfig";
import AQAvatarUploader from "@/components/Generics/AQAvatarUploader/AQAvatarUploader.vue";
import lazyLoad from "@/directives/LazyLoadImage.directive";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import ProcessModal from "@/components/Processes/ProcessModal.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";
import startProcessModal from "@/components/apps/applicationsPage/startProcessModal.vue";
import { SIDEBAR_BTNS } from "@/pages/main/routerPermissionsConst";
import createAppDialog from "@/components/apps/createAppDialog.vue";
import importAppDialog from "@/components/apps/importAppDialog.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";

const { getScrollHeight } = scroll;
let cardExpandedCounter = 0;

export default {
    name: "ApplicationsPage",
    directives: {
        lazyLoad
    },
    components: {
        FabricSearch,
        AQButton,
        AQMenu,
        AQAvatarUploader,
        AQEmptyState,
        AQAvatar,
        AQInput,
        AQUploader,
        ProcessModal,
        startProcessModal,
        AQTooltip,
        AQSearch,
        AQEmptySearch,
        AQDialog,
        AQDropdown,
        createAppDialog,
        importAppDialog,
        AQModal,
        AQHistory
    },
    props: {
        dashboard: Boolean,
        applicationPage: Boolean,
        mobileView: { type: Boolean, default: false },
        openProcessModalFromDiagram: { type: Boolean, default: false },
        typeProp: { type: String, default: "apps", validator: v => ["apps", "processes"].includes(v.toLowerCase()) }
    },
    data() {
        return {
            status: "",
            processSearch: "",
            type: this.typeProp,
            appSearch: "",
            pageName: "apps",
            resetSearchInput: false,
            value: null,
            createNewApp: false,
            showDlg: false,
            openModal: null,
            descriptionModel: null,
            processMarkedWithError: null,
            showSearch: false,
            noApps: true,
            noProcesses: true,
            fullProcessesList: [],
            processesEmptyState: false,
            emptyApps: 9,
            searchObject: {
                page: 0,
                search: "",
                ids: []
            },
            // pagedApps: [],
            firstLoad: false,
            popoverMenu: [],
            popoverProcess: [],
            deleteProcessDialog: false,
            abortArchiving: false,
            isExpanded: -1,
            keepOpen: false,
            processModalOpen: false,
            startProcessModalOpen: false,
            isInEdit: false,
            processEditData: {
                description: "",
                id: "",
                name: "",
                startable: "STARTABLE",
                retentionPeriod: null,
                retentionType: "INHERITED"
            },
            processToDelete: null,
            processToArchive: null,
            nrOfProcesses: null,
            importApp: false,
            skeletonState: false,
            displaySearch: false,
            routes: SIDEBAR_BTNS,
            openRenameProcess: false,
            hasProcessNameError: false,
            renameProcessValue: "",
            errorProcessname: "",
            processNameWrongPattern: false,
            processDuplicatedName: false,
            selectedProcessForRename: null,
            changeHistoryData: [],
            changeHistoryModal: false,
            changeHistoryCurrentPage: 0,
            changeHistoryHasMoreItems: true,
            deleteDialogMsg: "",
            deleteDialogTitle: "",
            markActionInProgress: false,
            recoverActionInProgress: false,
            isActive: true
        };
    },
    computed: {
        ...mapGetters("apps", ["apps", "allAppsNumber", "currentApp", "pagedApps", "getUserSystemPermissions", "getCurrentNrOfApps",
            "processList", "hasMoreApps", "getCurrentAppUserPermissions", "getStaticAppIdsList"]),
        ...mapGetters("userProfile", ["userCookieInfo"]),
        ...mapGetters("diagrams", ["getProcessWithError"]),
        ...mapGetters("version", ["latestVersionId"]),
        isAdmin() {
            return !!(
                this.getUserSystemPermissions
                && this.getUserSystemPermissions.hasOwnProperty("A")
                && this.getUserSystemPermissions.A.hasOwnProperty("g")
            );
        },
        getMargins() {
            let classToApply = "";
            if (this.type === "apps") {
                classToApply = this.showAddApplicationBtn ? "f-mr-md" : "q-mr-lg";
            } else {
                classToApply = this.showAddProcessBtn ? "f-mr-md" : "q-mr-lg";
            }
            return classToApply;
        },
        appsToShow() {
            let returnValue = [];
            if (this.type === "apps") {
                if (this.dashboard && this.pagedApps && this.pagedApps.length > 5) {
                    returnValue = this.pagedApps.slice(0, 6);
                } else {
                    returnValue = this.pagedApps;
                }
            } else {
                returnValue = this.processList;
            }
            return returnValue;
        },
        showAddProcessBtn() {
            return this.type === "processes" && this.editProcessPermissions(this.currentApp, this.getCurrentAppUserPermissions);
        },
        showAddApplicationBtn() {
            return this.type === "apps" && this.userCookieInfo.permissions.indexOf("f:ui:pd:c") !== -1;
        },
        displaySkeleton() {
            return (this.type === "apps" && this.noApps) || (this.type === "processes" && this.noProcesses && !this.processesEmptyState && !this.value)
            || this.skeletonState;
        },
        processOptions() {
            return [
                {
                    label: this.$t("processes.duplicate"),
                    value: "duplicate"
                },
                {
                    label: this.$t("processes.rename"),
                    value: "rename"
                },
                {
                    label: this.$t("generic.delete"),
                    value: "delete"
                }
            ];
        },
        errorProcessName() {
            let msg;
            if (this.processNameWrongPattern) {
                msg = this.$t("processes.wrongPatternErr");
            } else if (this.processDuplicatedName) {
                msg = this.$t("processes.duplicatedProcessName");
            }
            return msg;
        },
        checkProcessNameError() {
            return this.processNameWrongPattern || this.processDuplicatedName;
        },
        checkIfSameName() {
            return (this.selectedProcessForRename && this.renameProcessValue !== this.selectedProcessForRename.name) ? this.checkProcessNameError : true;
        },
        checkRenameBtn() {
            return !this.renameProcessValue || this.renameProcessValue.length < 3 || this.checkIfSameName;
        }
    },
    watch: {
        openProcessModalFromDiagram: {
            handler(val) {
                if (val) {
                    this.addProcessModalOpen();
                } else {
                    this.processModalOpen = false;
                }
            }
        },
        $route(to) {
            if (to.name !== "appsMainPage" && this.value && !this.$route.query) {
                this.value = null;
            } else if (to.name === "appsMainPage") {
                this.$root.$emit("hideCreateBtn", false);
            }
        },
        "$backendDrivenEvents.state.refreshApps": function (v) {
            if (v && this.type === "apps") {
                if (!this._inactive) {
                    const newPayload = {
                        page: 0,
                        search: this.value || "",
                        ids: [],
                        resetAppList: true
                    };
                    this.getApps(newPayload);
                    this.$backendDrivenEvents.state.refreshApps = false;
                }
            }
        },
        "$backendDrivenEvents.state.refreshAppPermissions": function (v) {
            if (v && this.type === "processes") {
                if (!this._inactive) {
                    this.actGetCurrentAppUserPermissions();
                }
                this.$backendDrivenEvents.state.refreshAppPermissions = false;
            }
        },
        "$backendWebsocketEvents.state.refreshProcessList": function (actionDetails) {
            if (actionDetails && this.type === "processes") {
                const actionTaken = actionDetails.data.split(":")[3];
                const processName = actionDetails.data.split(":")[4];
                if (!sessionStorage.getItem("wsActionUser") && this.$route.name === "ProcessList") {
                    if (actionTaken === "publish") {
                        this.callProcesses(true, this.value);
                    } else if ((actionTaken !== "mark" || !this.markActionInProgress) && (actionTaken !== "recover" || !this.recoverActionInProgress)) {
                        this.callProcesses(true, this.value, actionTaken, processName);
                    }
                }
                if (actionTaken !== "archive") {
                    sessionStorage.removeItem("wsActionUser");
                    if (this.$route.name === "process") {
                        this.callProcesses(true, this.value, "action");
                    }
                }

                this.$backendWebsocketEvents.state.refreshProcessList = null;
            }
        },
        "$backendWebsocketEvents.state.diagramChangedAppPage": function (actionDetails) {
            if (actionDetails) {
                const processName = actionDetails.data.split(":")[4];
                if (!sessionStorage.getItem("wsActionUser") && this.$route.name === "ProcessList") {
                    this.callProcesses(true, this.value);
                    this.$toast.showNotify({
                        type: "info",
                        message: this.$t("processes.processChanged", { name: processName }),
                        hasClose: false
                    });
                }
                if (this.$route.name === "ProcessList") {
                    sessionStorage.removeItem("wsActionUser");
                }
                this.$backendWebsocketEvents.state.diagramChangedAppPage = null;
            }
        }
    },
    mounted() {
        this.firstLoad = true;
        if (this.type === "processes") {
            this.callProcesses(true);
        } else {
            const { search } = this.$route.query;
            if (search) {
                this.showSearch = true;
                this.value = search;
                this.searchObject.search = search;
            }
            this.callApps();
            this.$emit("AppsLength", this.allAppsNumber);
            document.addEventListener("keypress", (event) => {
                if (!this.processModalOpen && !this.startProcessModalOpen && !this.createNewApp) {
                    if (!this.value && event.key !== "Enter") {
                        this.showSearch = true;
                        setTimeout(() => {
                            this.value = event.key;
                        }, 0);
                    }
                    setTimeout(() => {
                        this.showSearch = false;
                    }, 0);
                }
            });
        }
        this.processEvents();
        this.$root.$on("applicationsLoaded", () => {
            this.skeletonState = false;
        });
        this.appSearch = debounce((data) => {
            const searchText = data ? data.trim() : "";
            this.processSearch = "";
            if (this.type === "processes") {
                this.processSearch = searchText;
                this.callProcesses(false, searchText);
                const queriesAreDifferent = JSON.stringify({ search: searchText }) !== JSON.stringify(this.$route.query);
                const query = searchText ? { search: searchText } : {};
                if (queriesAreDifferent && this.isActive) {
                    this.$router.replace({ path: `/applications/${this.currentApp.id}/processes`, query });
                }
            } else if (!searchText || !searchText.length) {
                eventBus.$emit("appSearch", "");
                this.searchObject.search = searchText;
                this.searchObject.page = 0;
                this.searchObject.ids = [];
                this.skeletonState = true;
            } else if (searchText.length >= 2 && this.searchObject.search !== searchText) {
                this.skeletonState = true;
                this.searchObject.search = searchText;
                this.searchObject.page = 0;
                this.searchObject.ids = [];
                eventBus.$emit("appSearch", searchText);
            }
        }, 600);
    },
    activated() {
        this.value = "";
        const { scrollContainer } = this.$refs;
        if (scrollContainer) {
            scrollContainer.style.height = "";
        }
        if (this.openProcessModalFromDiagram) {
            this.addProcessModalOpen();
        }
        if (!this.firstLoad) {
            this.processEvents();
            if (this.type === "processes") {
                this.callProcesses(true);
            } else {
                this.callApps(true);
            }
        }
        if (this.$route.query && Object.keys(this.$route.query).length && this.$route.query.search) {
            this.showSearch = false;
            this.$nextTick(() => {
                this.showSearch = true;
                this.value = this.$route.query.search;
                this.processSearch = this.$route.query.search;
            });
        }
        this.isActive = true;
    },
    destroyed() {
        this.$root.$off("oneAtATime-process");
        this.$root.$off("openChangeHistory");
        this.$root.$off("showMoreChangeHistory");
        this.$root.$off("oneAtATime-process-delete");
        this.$root.$off("oneAtATime-process-rename");
    },
    deactivated() {
        this.value = "";
        this.isActive = false;
        this.resetSearchInput = true;
        setTimeout(() => {
            this.resetSearchInput = false;
        }, 200);
        this.$root.$off("oneAtATime-process");
        this.$root.$off("openChangeHistory");
        this.$root.$off("showMoreChangeHistory");
        this.$root.$off("oneAtATime-process-delete");
        this.$root.$off("oneAtATime-process-rename");
        this.firstLoad = false;
        this.resetChangeHistory();
    },
    methods: {
        ...mapActions("apps", [
            "getPagedApps",
            "getAllApps",
            "exportApplication",
            "getAppsNumber",
            "getAppProcesses",
            "duplicateProcesses",
            "renameProcess",
            "actCancelArchiving",
            "actDeleteProcess",
            "getAppSettingsInfo",
            "actGetUserSystemPermissions",
            "actGetCurrentAppUserPermissions",
            "getProcessInstancesInformation",
            "actMarkForArchiving",
            "recoverProcess"
        ]),
        ...mapActions("version", ["getLatestVersionId"]),
        ...mapActions("components", ["getLatestAppInterfaces", "getHistoryData"]),
        editProcessPermissions,
        publishAppPermissions,
        getImagePath(id) {
            let path = null;
            if (id) {
                path = `${ENGINE_REST_PATH}/app/files/${id}/IMAGE`;
            }
            return path;
        },
        loadMore(scrollPage) {
            if (this.hasMoreApps && this.$router.currentRoute.name !== "AddToArchive") {
                const { scrollContainer } = this.$refs;
                const scrollHeight = getScrollHeight(scrollContainer);
                const windowHeight = window.innerHeight - 40;
                if (
                    scrollPage.direction === "down"
                    && scrollPage.position
                    && scrollPage.position >= scrollHeight - windowHeight
                    && this.searchObject.page <= this.allAppsNumber / 18
                ) {
                    this.searchObject.page++;
                    if (this.getStaticAppIdsList.length > 0) {
                        this.searchObject.ids = this.getStaticAppIdsList;
                    }
                    this.getPagedApps(this.searchObject);
                }
            }
        },
        resetChangeHistory() {
            this.changeHistoryData = [];
            this.changeHistoryCurrentPage = 0;
            this.changeHistoryHasMoreItems = true;
        },
        getChangeHistory() {
            if (this.changeHistoryHasMoreItems) {
                const payload = {
                    searchType: "CHANGE_HISTORY",
                    module: "ProcessDiagram",
                    applicationId: this.currentApp.id,
                    page: this.changeHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    if (data && data.data && data.data.history) {
                        this.changeHistoryData = this.changeHistoryData.concat(data.data.history);
                        this.changeHistoryHasMoreItems = data.data.hasMorePages;
                    }
                    this.changeHistoryModal = true;
                });
            } else {
                this.changeHistoryModal = true;
            }
        },
        getOpenCreateLabel(item) {
            return item.nrOfStartableProcesses === 1 ? this.$t("processes.startProcessBtn") : this.$t("generic.open");
        },
        goToArchiveApplication(app) {
            if (app.canManage) {
                this.$store.commit("apps/setCurrentApp", app);
                this.$store.commit("main/setCurrentApplicationId", app.id);
                this.$router.push("/applications/AddToArchive");
            }
        },
        editViewApplication(item) {
            localStorage.removeItem("selectedDocument");
            this.$root.$emit("reportView", false);
            this.$store.commit("apps/setCurrentApp", item);
            this.$store.commit("main/setCurrentApplicationId", item.id);
            this.$store.commit("diagrams/setProcessWithError", {});
            this.routeToModules(item);
            this.$store.dispatch("admin/actionGetGroupsApps");
            this.$backendWebsocketEvents.startWebsocket(item.id);
        },
        openSettingsModal(item) {
            this.processEditData.description = item.description;
            this.processEditData.id = item.id;
            this.processEditData.name = item.name;
            this.processEditData.startable = item.startable;
            this.processEditData.retentionPeriod = item.retentionPeriod;
            this.processEditData.retentionType = item.retentionType;
            this.isInEdit = true;
            this.processModalOpen = true;
        },
        refreshProcessList() {
            this.callProcesses(true);
        },
        propsForAvatar(item) {
            const statusCodes = {
                NOT_PUBLISHED: "appUnpublished",
                PUBLISHED: "appPublished",
                UNPUBLISHED_CHANGES: "publishedNewChanges"
            };

            return {
                type: statusCodes[item.publishStatus] || "app",
                isEditable: false,
                size: 48
            };
        },
        addProcessModalOpen() {
            this.isInEdit = false;
            this.processEditData.description = "";
            this.processEditData.id = "";
            this.processEditData.name = "";
            this.processEditData.startable = "STARTABLE";
            this.processEditData.retentionPeriod = null;
            this.processEditData.retentionType = "INHERITED";
            this.processModalOpen = true;
        },
        routeToModules(item) {
            const { permission } = item;
            const hierarchy = this.currentApp.type === "GF" ? ["DI", "IB", "DB", "AP", "DM", "CD", "PB", "DP", "RP", "AS"]
                : ["DI", "SC", "IB", "DB", "AP", "DM", "CD", "PB", "DP", "RP", "AS"];
            if (permission && permission.g && permission.g === "o") {
                this.$router.push(`/applications/${this.currentApp.id}/processes`);
            } else {
                for (let i = 0; i < hierarchy.length; i++) {
                    if (permission && permission[hierarchy[i]] && permission[hierarchy[i]].g && permission[hierarchy[i]].g === "w") {
                        this.findElemFn(hierarchy[i]);
                        return;
                    }
                }
                if (item.canManage) {
                    this.$router.push(`/applications/${this.currentApp.id}/settings/general`);
                    return;
                }
                for (let i = 0; i < hierarchy.length; i++) {
                    if (permission && permission[hierarchy[i]] && Object.keys(permission[hierarchy[i]]).length && hierarchy[i] !== "RP") {
                        if (permission[hierarchy[i]]
                        && permission[hierarchy[i]].g && permission[hierarchy[i]].g === "r") {
                            this.findElemFn(hierarchy[i]);
                            return;
                        }
                    } else if (permission && permission[hierarchy[i]] && Object.keys(permission[hierarchy[i]]).length && hierarchy[i] === "RP"
                    && (permission[hierarchy[i]].ST.g === "r" || permission[hierarchy[i]].TI.g === "r")) {
                        this.$router.push(`/applications/${this.currentApp.id}/analytics/processLiveView`);
                        return;
                    }
                }
            }
        },
        findElemFn(itm) {
            const route = this.routes.find(el => {
                let elToFilter = "";
                if (typeof el.permissionCode === "string") {
                    elToFilter = el.permissionCode === itm;
                } else if (Array.isArray(el.permissionCode) && el.permissionCode.length) {
                    elToFilter = el.permissionCode.find(it => it === itm);
                } else if (el.permissionCode.parent) {
                    elToFilter = el.permissionCode.parent === itm;
                }
                return elToFilter;
            });
            this.$router.push(`/applications/${this.currentApp.id}${route.to}`);
        },
        addApplication() {
            this.createNewApp = true;
            this.$store.commit("apps/setCurrentApp", {});
            this.getLatestVersionId().then(() => {
                this.currentApp.appVersion = this.latestVersionId;
            });
        },
        goToReports(app) {
            if (app.permission && app.permission.RP) {
                if (app.permission.RP.g === "w") {
                    this.$root.$emit("editView", false);
                } else {
                    this.$root.$emit("reportView", true);
                }
            }
            this.$backendWebsocketEvents.startWebsocket(app.id);
            this.$store.commit("apps/setCurrentApp", app);
            this.$store.commit("main/setCurrentApplicationId", app.id);
            this.$router.push(`/applications/${app.id}/analytics/processLiveView`);
        },
        goToSearch(app) {
            if (app.permission && app.permission.RP) {
                if (app.permission.RP.g === "w") {
                    this.$root.$emit("editView", false);
                } else {
                    this.$root.$emit("reportView", true);
                }
            }
            this.$backendWebsocketEvents.startWebsocket(app.id);
            this.$store.commit("apps/setCurrentApp", app);
            this.$store.commit("main/setCurrentApplicationId", app.id);
            this.$router.push(`/applications/${app.id}/dataViews`);
        },
        goToExport(app) {
            this.exportApplication(app).then(
                () => {},
                () => {
                    this.$toast.showNotify({
                        message: this.$t("apps.downloadError"),
                        type: "error",
                        timeout: 1000
                    });
                }
            );
        },
        goToTasks(app) {
            this.$store.commit("apps/setCurrentApp", app);
            this.$store.commit("tasks/setSelectedTasksFilter", { applications: [app.id] });
            this.$store.commit("tasks/setSelectedAppName", app.name);
            this.$router.push({ path: "/tasks/myTasks", query: { tab: "todo" } });
        },
        open(item) {
            if (item.nrOfStartableProcesses === 1) {
                localStorage.removeItem("registerAppId");
                const applicationProps = {
                    appId: item.processDefinitionId
                };
                this.$store.commit("components/resetState");
                this.$store.dispatch("apps/startApp", applicationProps);
            } else {
                this.$store.commit("apps/setCurrentApp", item);
                this.startProcessModalOpen = true;
            }
        },
        goToDiagram(item) {
            this.$store.commit("apps/setCurrentProcess", item);
            this.$store.commit("main/setCurrentProcessId", item.id);
            this.$store.commit("diagrams/setCopyOfInitialContentDiagram", []);
            this.$store.commit("diagrams/setCopyOfInitialConnectorsDiagram", []);
            this.$store.commit("diagrams/setCopyOfInitialMessagesDiagam", []);
            if (item.markedForArchive) {
                this.$router.push({
                    path: `/applications/${this.currentApp.id}/processes/${item.id}`,
                    params: {
                        ...this.$route.params, isMarkedForArchiving: true
                    }
                });
            } else {
                this.$router.push(`/applications/${this.currentApp.id}/processes/${item.id}`);
            }
        },
        openStatusReport(item) {
            this.$store.commit("apps/setCurrentProcess", item);
            this.$router.push({
                name: "StatusReport",
                params: {
                    process: item
                }
            });
        },
        cancelArchiving(item) {
            this.abortArchiving = true;
            this.processToArchive = item;
        },
        viewAllApps() {
            this.$router.push("/applications");
        },
        hasPermission(item, type) {
            let hasPermission;
            const { permission } = item;
            if (permission) {
                const hasDataViewRights = () => Object.entries(permission.DP).find(([, val]) => val.PP);
                const hasSearchPermission = () => (type === "DP" ? (Object.keys(permission[type]).length && hasDataViewRights())
                    : (type === "I" || permission[type].ST || permission[type].TI));

                hasPermission = (permission.hasOwnProperty("g") && permission.g === "o") || (type && permission[type] && hasSearchPermission());
            }
            return hasPermission;
        },
        canExport(item) {
            return (
                item.permission
                && (item.permission.hasOwnProperty("g")
                    || (item.permission.hasOwnProperty("AS") && item.permission.AS.hasOwnProperty("g"))
                    || (item.permission.hasOwnProperty("AS") && item.permission.AS.hasOwnProperty("EX")))
            );
        },
        canOpen(item) {
            const hasInitiateProcess = () => {
                const { permission } = item || {};
                let hasRight;
                if (permission && permission.DP) {
                    hasRight = Object.entries(permission.DP).find(([, val]) => val.SP && val.SP.I);
                }
                return hasRight;
            };

            return item.active && (this.hasPermission(item, "I") || hasInitiateProcess()) && item.nrOfStartableProcesses
            && (item.publishStatus === "PUBLISHED" || item.publishStatus === "UNPUBLISHED_CHANGES");
        },
        editPermissions(item) {
            let hasRights;
            if (item.permission) {
                if (item.permission.hasOwnProperty("g")) {
                    hasRights = item.permission.g === "o";
                } else {
                    const checkOnlyReports = () => {
                        const { permission } = item;
                        const checkPermissions = () => ((permission.DP && permission.RP && (permission.I || permission.SB))
                        || (permission.I && permission.RP && permission.SB));

                        return ((Object.keys(permission).length === 1 && (permission.RP || (permission.DP && Object.keys(permission.DP).length)))
                        || (Object.keys(permission).length === 2 && permission.RP && (permission.DP || permission.I))
                        || (Object.keys(permission).length === 3 && checkPermissions())
                        || (Object.keys(permission).length === 4 && permission.I && permission.RP && permission.DP && permission.SB));
                    };
                    if (!checkOnlyReports()) {
                        hasRights = Object.keys(item.permission).find(uiCode => {
                            let response;
                            const element = item.permission[uiCode];
                            if (element.g) {
                                response = element.g === "w" && uiCode !== "SB";
                            } else {
                                response = Object.keys(element).find(subModuleCode => element[subModuleCode].g === "w" && uiCode !== "SB");
                            }
                            return response;
                        });
                    }
                }
            }
            return !!hasRights;
        },
        showViewBtn(item) {
            const param = this.type === "apps" ? item : this.currentApp;
            return !this.mobileView && !this.hasOnlyViewSideBar(param) && !this.hasOnlySBInitiator(param) && !this.hasOnlyInitiatorAndSB(param)
            && !this.hasOnlySBPerspective(param) && !(this.hasOnlyReportsView(param) || this.hasOnlyInitiator(param));
        },
        hasRightsComp() {
            return this.editProcessPermissions(this.currentApp);
        },
        showEditBtn(item) {
            const showEdit = this.type === "apps" ? this.editPermissions(item)
                : this.editProcessPermissions(this.currentApp, this.getCurrentAppUserPermissions);
            return !this.mobileView && (this.type === "apps" ? this.isAdmin || showEdit : showEdit) && !item.markedForArchive;
        },
        showSearchBtn(item) {
            let count = 1;
            if (this.showViewBtn(item) || this.showEditBtn(item)) {
                count++;
            }
            if (this.canOpen(item)) {
                count++;
            }
            if (this.hasPermission(item, "RP")) {
                count++;
            }
            return count < 4;
        },
        showSettingsBtn(item) {
            return !this.mobileView && this.editProcessPermissions(this.currentApp, this.getCurrentAppUserPermissions) && !item.markedForArchive;
        },
        hasOnlySBInitiator(item) {
            return item.permission && item.permission.hasOwnProperty("I") && item.permission.hasOwnProperty("SB") && Object.keys(item.permission).length === 2;
        },
        hasOnlyInitiator(item) {
            const checkInitiator = () => {
                const { length } = Object.keys(item.permission);
                let hasInitiator;
                if (length === 1 || (length === 2 && item.permission.DP && !Object.keys(item.permission.DP).length)) {
                    hasInitiator = true;
                }
                return hasInitiator;
            };
            return item.permission && item.permission.hasOwnProperty("I") && checkInitiator();
        },
        hasOnlyViewSideBar(item) {
            return item.permission && item.permission.hasOwnProperty("SB") && Object.keys(item.permission).length === 1;
        },
        hasOnlyInitiatorAndSB(item) {
            const { permission } = item;
            return permission && Object.keys(permission).length === 3 && permission.I && permission.SB && permission.DP && !Object.keys(permission.DP).length;
        },
        hasOnlySBPerspective(item) {
            return item.permission && item.permission.hasOwnProperty("SB") && item.permission.hasOwnProperty("DP") && Object.keys(item.permission).length === 2;
        },
        getApps(payload) {
            this.getPagedApps(payload || this.searchObject).then(() => {
                this.noApps = false;
                this.$emit("appsLoaded");
                setTimeout(() => {
                    this.$root.$emit("existApps");
                }, 1000);
            });
        },
        callApps(fromActivated) {
            this.$store.commit("apps/resetPagedApps");
            if (fromActivated) {
                this.searchObject = {
                    page: 0,
                    search: "",
                    ids: []
                };
            }
            this.getApps();
        },
        callProcesses(refreshFullList, searchText, action, processName) {
            const searchTerm = searchText || "";
            this.getAppProcesses({ applicationId: this.currentApp.id, searchTerm }).then(rsp => {
                if (rsp.data) {
                    const copyOfRsp = [...rsp.data];
                    if (refreshFullList) {
                        this.fullProcessesList = copyOfRsp;
                    }
                    this.nrOfProcesses = copyOfRsp.length;
                    this.noProcesses = !copyOfRsp.length;
                    this.processesEmptyState = searchTerm ? false : this.noProcesses;
                    if (!searchTerm) {
                        this.$root.$emit("showPublish",
                            { noProcesses: this.noProcesses, showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
                    }
                    this.$root.$emit("setReadonlyTag", this.$route.params && this.$route.params.permissions ? this.$route.params.permissions.readonly : false);
                    this.$store.commit("apps/setProcessList", copyOfRsp);
                    this.$root.$emit("refreshPublishBtnState", !!searchText);
                    this.$emit("input", copyOfRsp.length);
                    if (action) {
                        if (["unmark", "update"].includes(action)) {
                            this.$toast.showNotify({
                                type: "info",
                                message: this.$t("processes.processChanged", { name: processName }),
                                hasClose: false
                            });
                        } else if (action === "mark") {
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("processes.processDeleted", { name: processName }),
                                hasClose: false
                            });
                        } else if (this.$route.name !== "process") {
                            this.$toast.showNotify({
                                type: "info",
                                message: this.$t("processes.listChanged"),
                                hasClose: false
                            });
                        }
                    }
                    if (Object.keys(this.currentApp).length) {
                        this.getAppSettingsInfo(this.currentApp).then(data => {
                            this.currentApp.publishStatus = data.data.publishStatus;
                            this.$store.commit("apps/setCurrentApp", this.currentApp);
                        });
                    }
                }
            });
        },
        hasOnlyReportsView(item) {
            const data = item.permission;
            const checkPermissionData = () => ((data.DP && data.SB && (data.RP || data.I)) || (data.I && data.SB && data.RP));

            const checkPermission = () => ((Object.keys(data).length === 1 && (data.RP || (data.DP && Object.keys(data.DP).length)))
                    || (Object.keys(data).length === 2 && data.RP && (data.DP || data.SB || data.I))
                    || (Object.keys(data).length === 3 && checkPermissionData())
                    || (Object.keys(data).length === 4 && data.I && data.RP && data.DP && data.SB));
            return (data && checkPermission());
        },
        moreOptions(item) {
            const optionList = [];
            if (this.type === "apps" && !this.mobileView && this.hasPermission(item, "DP") && !this.showSearchBtn(item)) {
                optionList.push({ label: this.$t("generic.dataSearchPerspective"), value: "search" });
            }
            if (this.isAdmin) {
                optionList.push({ label: this.$t("apps.addToArchive.optionLabel"), value: "archive" });
            }
            if (this.isAdmin || this.canExport(item)) {
                optionList.push({ label: this.$t("apps.export"), value: "export" });
            }
            return optionList;
        },
        selectedOption($event, item) {
            const [{ value }] = $event;
            if (value === "archive") {
                this.goToArchiveApplication(item);
            } else if (value === "export") {
                this.goToExport(item);
            } else if (value === "search") {
                this.goToSearch(item);
            }
        },
        selectedOptionProcess($event, item) {
            const [{ value }] = $event;
            if (value === "delete") {
                this.processToDelete = { ...item };
                if (item.status === "NOT_PUBLISHED") {
                    this.deleteDialogTitle = this.$t("processes.deleteUnpublishedMessageTitle", { process: item.name });
                    this.deleteDialogMsg = {
                        firstMsg: this.$t("processes.deleteUnpublishedFirstMsg", { process: item.name }),
                        secondMsg: this.$t("processes.deleteUnpublishedSecondMsg")
                    };
                    this.deleteProcessDialog = true;
                } else {
                    this.getProcessInstancesInformation(item.id).then(
                        ({ data }) => {
                            let processNr = 0;
                            data.forEach(({ nrOfInstances }) => {
                                processNr += nrOfInstances;
                            });

                            this.deleteDialogTitle = this.$t("processes.deletePublishedMessageTitle", { process: item.name });
                            this.deleteDialogMsg = {
                                firstMsg: this.$t("processes.deletePublishedFirstMsg"),
                                processNr,
                                insideMsg: this.$tc("processes.deletePartMsg", processNr > 0 ? 2 : 1),
                                secondMsg: this.$t("processes.deletePublishedSecondMsg")
                            };
                            this.deleteProcessDialog = true;
                        }
                    );
                }
            } else if (value === "rename") {
                this.openRenameProcess = true;
                this.selectedProcessForRename = item;
                this.renameProcessValue = item.name;
            } else if (value === "duplicate") {
                sessionStorage.setItem("wsActionUser", true);
                this.duplicateProcesses(item.id).then(() => {
                    this.callProcesses(true, this.value);
                }).catch(() => {
                    sessionStorage.removeItem("wsActionUser");
                });
            }
        },
        validateProcessName() {
            this.$oneAtATime.createRoom("process", this.selectedProcessForRename.id, "rename");
        },
        cancelProcessName() {
            this.renameProcessValue = "";
            this.processNameWrongPattern = false;
            this.processDuplicatedName = false;
            this.selectedProcessForRename = null;
            this.openRenameProcess = false;
        },
        deleteProcessOk() {
            this.$oneAtATime.createRoom("process", this.processToDelete.id, "delete");
        },
        abortArchivingOk() {
            sessionStorage.setItem("wsActionUser", true);
            this.actCancelArchiving(this.processToArchive.id).then(() => {
                this.callProcesses();
            }).catch(() => {
                sessionStorage.removeItem("wsActionUser");
            });
        },
        cardClick(index) {
            this.isExpanded = this.isExpanded === index ? -1 : index;
            const { scrollContainer } = this.$refs;
            if (this.isExpanded === index) {
                document.getElementById(`idCollapse-${index}`).addEventListener("transitionend", function afterTransition() {
                    const el = document.getElementById(`card-${index}`);
                    let rect = el.getBoundingClientRect();
                    let parentContainer = scrollContainer.getBoundingClientRect();
                    const isVisible = rect.bottom < parentContainer.bottom && rect.top >= parentContainer.top;
                    if (!isVisible) {
                        el.scrollIntoView({ behavior: "auto", block: "nearest" });
                    }
                    rect = el.getBoundingClientRect();
                    parentContainer = scrollContainer.getBoundingClientRect();
                    if (!(rect.bottom <= parentContainer.bottom && rect.top >= parentContainer.top) && !cardExpandedCounter) {
                        const scrollHeight = getScrollHeight(scrollContainer);
                        scrollContainer.style.height = `${scrollHeight}px`;
                        cardExpandedCounter++;
                    }
                    document.getElementById(`idCollapse-${index}`).removeEventListener("transitionend", afterTransition);
                });
            } else if (cardExpandedCounter === 1) {
                const scrollHeight = getScrollHeight(scrollContainer);
                scrollContainer.style.height = `${scrollHeight - 95}px`;
                cardExpandedCounter--;
            }
        },
        clickOutside(index) {
            if (this.keepOpen) {
                this.keepOpen = false;
                this.$refs.cardParent[index].focus();
            } else {
                this.isExpanded = -1;
                const { scrollContainer } = this.$refs;
                if (cardExpandedCounter === 1) {
                    const scrollHeight = getScrollHeight(scrollContainer);
                    scrollContainer.style.height = `${scrollHeight - 95}px`;
                    cardExpandedCounter--;
                }
            }
        },
        checkCardIndex(index) {
            this.keepOpen = this.isExpanded === index;
        },
        stopProp(event) {
            event.stopPropagation();
        },
        statusInfo(status) {
            let tooltip = "";
            if (status === "PUBLISHED") {
                tooltip = this.$t("diagrams.components.setProcess.publishedTooltip");
            } else if (status === "NOT_PUBLISHED") {
                tooltip = this.$t("diagrams.components.setProcess.unpublishedTooltip");
            } else {
                tooltip = this.$t("diagrams.components.setProcess.unpublishedChangesTooltip");
            }
            return tooltip;
        },
        checkProcessName(value) {
            if (value && value.length >= 3 && value !== this.selectedProcessForRename.name) {
                const validatePattern = new RegExp("^[a-zA-Z][ a-zA-Z0-9_-]*$"); // alphanumeric chars and space - _
                this.processNameWrongPattern = !validatePattern.test(value);
                this.processDuplicatedName = this.processList.some(elem => elem.name === value);
            } else {
                this.processNameWrongPattern = false;
                this.processDuplicatedName = false;
            }
        },
        modalAction(evt) {
            if (evt === "close") {
                this.changeHistoryModal = false;
            }
        },
        menuItemChangeHistoryClicked(evt) {
            if (evt.menuOptionClicked === "recover") {
                const myDate = new Date();
                const offsetInMinutes = myDate.getTimezoneOffset();
                const payload = {
                    module: "ProcessDiagram",
                    applicationId: this.currentApp.id,
                    elementId: evt.elementId,
                    commitId: evt.items[0].commitId,
                    offsetMinutes: parseInt(offsetInMinutes, 10)
                };
                this.recoverActionInProgress = true;
                this.recoverProcess(payload).then(response => {
                    if (response && response.data) {
                        if (response.data.isSuccessful === true) {
                            this.recoverActionInProgress = false;
                            this.changeHistoryModal = false;
                            this.callProcesses(true, this.value, evt.menuOptionClicked, evt.elementName);
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("versioning.processRecovered"),
                                timeout: 2000,
                                hasClose: true
                            });
                            this.$oneAtATime.destroyCurrentRoom();
                        } else {
                            const errorCodes = {
                                ALREADY_RECOVERED: this.$t("versioning.processAlreadyRecovered"),
                                MISSING_GUI: this.$t("versioning.processNotFound"),
                                NOT_DELETE: this.$t("versioning.interfaceNotDeleteEvent")
                            };
                            if (errorCodes[response.data.errorCode]) {
                                this.$toast.showNotify({
                                    type: "error",
                                    message: errorCodes[response.data.errorCode],
                                    timeout: 3000,
                                    hasClose: true
                                });
                            }
                        }
                    }
                });
            }
        },
        processEvents() {
            this.$root.$on("oneAtATime-process-delete", (value) => {
                if (value === "true") {
                    if (this.processToDelete) {
                        if (this.processToDelete.status === "NOT_PUBLISHED") {
                            sessionStorage.setItem("wsActionUser", true);
                            this.actDeleteProcess(this.processToDelete.id).then(() => {
                                this.$store.commit("apps/setProcessList", this.processList.filter(elem => elem.id !== this.processToDelete.id));
                                this.fullProcessesList = this.fullProcessesList.filter(elem => elem.id !== this.processToDelete.id);

                                if (this.currentApp.hasOwnProperty("nrOfProcesses")) {
                                    this.currentApp.nrOfProcesses = this.processList.length;
                                    this.nrOfProcesses = this.processList.length;
                                    if (!this.currentApp.nrOfProcesses) {
                                        delete this.currentApp.nrOfProcesses;
                                    }
                                }
                                this.$toast.showNotify({
                                    type: "success",
                                    message: this.$t("processes.processDeleted", { name: this.processToDelete.name }),
                                    hasClose: false
                                });
                                if (!this.fullProcessesList.length) {
                                    this.processesEmptyState = true;
                                }
                                this.$oneAtATime.destroyCurrentRoom();
                            }).catch(() => {
                                sessionStorage.removeItem("wsActionUser");
                            });
                        } else {
                            this.markActionInProgress = true;
                            this.actMarkForArchiving(this.processToDelete.id).then(() => {
                                this.markActionInProgress = false;
                                this.$oneAtATime.destroyCurrentRoom();
                                this.callProcesses(true, this.value, "mark", this.processToDelete.name);
                            });
                        }
                    }
                } else if (value === "false") {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("processes.errorOnDelete", { name: this.processToDelete.name })
                    });
                }
            });
            this.$root.$on("oneAtATime-process-rename", (value) => {
                if (value === "false") {
                    setTimeout(() => {
                        this.$toast.showNotify({
                            type: "error",
                            message: this.$t("processes.errorOnRename", { user: this.$oneAtATime.state.$currentEditingUser })
                        });
                    }, 500);
                } else if (value === "true") {
                    if (this.selectedProcessForRename) {
                        const { id } = this.selectedProcessForRename;
                        const payload = {
                            appId: this.currentApp.id,
                            id,
                            name: this.renameProcessValue
                        };

                        this.renameProcess(payload).then(
                            () => {
                                this.openRenameProcess = false;
                                this.selectedProcessForRename = null;
                                this.processList.forEach(process => {
                                    if (process.id === id) {
                                        process.name = this.renameProcessValue;
                                    }
                                });
                                this.$toast.showNotify({
                                    type: "success",
                                    message: this.$t("processes.successfullyRenamed")
                                });
                                this.callProcesses(true);
                                this.$oneAtATime.destroyCurrentRoom();
                            }
                        )
                            .catch(() => {
                                this.$toast.showNotify({
                                    type: "error",
                                    message: this.$t("processes.failedRename")
                                });
                                this.$oneAtATime.destroyCurrentRoom();
                            });
                    }
                }
            });
            this.$root.$on("showMoreChangeHistory", routeName => {
                if (routeName === this.$route.name) {
                    this.changeHistoryCurrentPage += 1;
                    this.getChangeHistory();
                }
            });
            this.$root.$on("openChangeHistory", routeName => {
                if (routeName === this.$route.name) {
                    this.resetChangeHistory();
                    this.getChangeHistory();
                }
            });
        }
    }
};
